export {default} from './Stats.connect';
